<script setup lang="ts">
const t2 = useT2({})
const { seller } = useSeller('server')

useHead({
  title: t2('About us'),
})
// if (import.meta.server) {
//
// useServerHead({
//   script: [
//     seoSchema([
//       {
//         '@type': 'AboutPage',
//         mainEntity: {
//           '@type': 'Organization',
//           name: 'Example Company',
//           url: 'https://www.example.com',
//           logo: 'https://www.example.com/logo.png',
//           foundingDate: '2010-01-01',
//           founder: {
//             '@type': 'Person',
//             name: 'Jane Smith',
//           },
//           address: {
//             '@type': 'PostalAddress',
//             streetAddress: '123 Main Street',
//             addressLocality: 'Anytown',
//             addressRegion: 'State',
//             postalCode: '12345',
//             addressCountry: 'Country',
//           },
//           contactPoint: contactPoint(),
//           sameAs: sameAs(),
//           description: 'Example Company is a leading provider of innovative solutions in the tech industry. We specialize in creating high-quality products that enhance the lives of our customers.',
//           employee: [
//             {
//               '@type': 'Person',
//               name: 'John Doe',
//               jobTitle: 'Chief Executive Officer',
//               image: 'https://www.example.com/images/john-doe.jpg',
//             },
//             {
//               '@type': 'Person',
//               name: 'Emily Johnson',
//               jobTitle: 'Chief Technology Officer',
//               image: 'https://www.example.com/images/emily-johnson.jpg',
//             },
//           ],
//         },
//       },

//       {
//         '@type': 'AboutPage',
//         mainEntity: {
//           '@type': 'Organization',
//           name: 'Example Company',
//           url: 'https://www.example.com',
//           logo: 'https://www.example.com/logo.png',
//           foundingDate: '2010-01-01',
//           numberOfEmployees: '250',
//           award: 'Best Tech Startup 2023',
//           address: {
//             '@type': 'PostalAddress',
//             streetAddress: '123 Main Street',
//             addressLocality: 'Anytown',
//             addressRegion: 'State',
//             postalCode: '12345',
//             addressCountry: 'Country',
//           },
//           contactPoint: contactPoint(),
//           sameAs: sameAs(),
//           description: 'Example Company is a leading provider of innovative solutions in the tech industry.',

//         },
//       },
//     ]),
//   ],
// })
</script>

<template>
  <AppMenu :title="t2('About us')">
    <template #content>
      <DocumentUi :document-id="seller?.doc?.aboutUs?._id" />
    </template>
  </AppMenu>
</template>
